import React from "react";
import { Link } from "react-router-dom";

export default function CustomLink({ children, className, ...props }) {
  return (
    <Link
      className={`inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 cursor-pointer duration-300 ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}
